import { render } from "./CategorySelection.vue?vue&type=template&id=8e8ff7f4&scoped=true"
import script from "./CategorySelection.vue?vue&type=script&lang=ts"
export * from "./CategorySelection.vue?vue&type=script&lang=ts"

import "./CategorySelection.vue?vue&type=style&index=0&id=8e8ff7f4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8e8ff7f4"

export default script